import { render, staticRenderFns } from "./tree-select-categorias.vue?vue&type=template&id=1bd8dc42&scoped=true"
import script from "./tree-select-categorias.vue?vue&type=script&lang=ts"
export * from "./tree-select-categorias.vue?vue&type=script&lang=ts"
import style0 from "./tree-select-categorias.vue?vue&type=style&index=0&id=1bd8dc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8dc42",
  null
  
)

export default component.exports